import React from 'react';
import NotificationMenuPresenter from './NotificationMenuPresenter';

const NotificationMenuContainer: React.FC = () => {
  return <NotificationMenuPresenter />;
};

export default NotificationMenuContainer;
